var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_vm._l((_vm.items),function(item,index){return [(index > 0)?_c('FontAwesomeIcon',{key:'arrow_' + index,staticClass:"breadcrumb__arrow",attrs:{"icon":['fal', 'angle-right']}}):_vm._e(),_c('BreadcrumbItem',{key:'item_' + index,attrs:{"value":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }